import { useEffect, useRef, useState } from 'react';

const useScrollThrottle = (timeout = 0, callback) => {
    const [throttledState, setThrottledState] = useState(null);
    const timeoutRef = useRef(-1);
    const lastState = useRef({
        scrollX: 0,
        scrollY: 0,
    });

    const updateScrollState = () => {
        if (typeof window === 'undefined') return;

        lastState.current = {
            scrollX: window.scrollX,
            scrollY: window.scrollY,
        };
    };

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const handleScroll = () => {
            updateScrollState();

            if (timeoutRef.current === -1) {
                timeoutRef.current = window.setTimeout(() => {
                    callback && callback(lastState.current);
                    setThrottledState(lastState.current);
                    timeoutRef.current = -1;
                }, timeout);
            }
        };

        updateScrollState();
        callback && callback(lastState.current);
        setThrottledState(lastState.current);

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [callback, timeout]);

    return throttledState;
};

export default useScrollThrottle;



// WEBPACK FOOTER //
// ./src/utils/useScrollThrottle.js